// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__WRJzu","presentationContainer":"styles_presentationContainer__9Fhmy","works":"styles_works__AWrUr","worksContainer":"styles_worksContainer__WOv3f"};